export enum AgentCopilotContent {
  ADAPTIVE_CARD = 'AdaptiveCard',
  RT_SUMMARY = 'rtSummary',
  KB_ANSWERS = 'kbAnswers',
  SENTIMENT = 'sentimentAndReason',
  KB_LINKS = 'kbLinks',
  KB_IMAGES = 'kbImages',
  KB_INTERNAL_USE = 'kbInternalUse',
  TEXT = 'Text',
  FINAL_SUMMARY = 'finalSummary',
  FINAL_SUMMARY_NOTES = 'finalSummaryNotes',
  KB_ANSWERS_VOICE = 'kbAnswers_Voice',
  KB_IMAGES_VOICE = 'kbImages_Voice',
  ENLIGHTEN_AGENT_COPILOT = 'Enlighten Agent Copilot',
  AGENT_COPILOT = 'agentCopilot',
  COPILOT_REQUEST_STATUS = 'currentRequestState',
  KB_COMBO = 'kbCombo',
  KB_COMBO_VOICE = 'kbCombo_Voice',
  SALES_OFFER = 'salesOffer',
  SALES_OFFER_VOICE = 'salesOffer_Voice',
  TRANSFER_SUMMARY = 'transferSummary',
  COMPLIANCE_CARD = 'compliance',
  COMPLIANCE_CARD_VOICE = 'compliance_Voice',
  CONVERSATION_ASSISTANCE = 'conversationAssistance',
  INTENT_ASSISTANCE = 'intentAndAssistance',
  JOURNEY_SUMMARY = 'journeySummary',
  AGENT_TRANSFER = 'agentTransfer',
  AUTOPILOT_TRANSFER = 'autopilotTransfer',
  INTENT_COMPLETED = 'intentSuccess',
  INTENT_INPROGRESS = 'intentInprogress',
  BEHAVIORAL_GUIDANCE = 'behavioralGuidance',
  EMAIL_RESPONSE_GENERATED = 'emailResponseGenerated',
  EMAIL_RESPONSE_SUGGESTED = 'emailResponseSuggested',
  EMAIL_RESPONSE_SUGGESTED_LIVE = 'emailResponseSuggestedLive',
  EMAIL_RESPONSE_GENERATED_LIVE = 'emailResponseGeneratedLive',
  FEEDBACK = 'feedback',
  KB_COMBO_EMAIL = 'kbCombo_Email',
}
